import React from 'react';
import { Link } from 'react-router-dom';
import path from 'path';
import Tooltip from 'mrf/view/Tooltip';
import { EditIcon } from 'styles/components/Icons';
import { generateHtmlId } from 'mrf/utils/StringGenerators';

export default function EditButton({ match, id, size=30 }) {
    return <Link
        to={path.join(match.url, `edit/${id}`)}
        id={generateHtmlId('edit', id)}
        name={generateHtmlId('edit', 'link')}
    >
            <Tooltip content='Edit'>
                <EditIcon size={size} />
            </Tooltip>
    </Link>;
}
